import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete, {
  createFilterOptions
} from "@material-ui/lab/Autocomplete";
import { List } from "react-virtualized";
import { Checkbox, IconButton, Popper, Tooltip } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import "./Virtualized.less";
import { removeDuplicates, validateEmail } from "../../../utils/helper";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { InfoOutlined } from "@material-ui/icons";

const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, role, ...other } = props;
  const itemCount = Array.isArray(children) ? children.length : 0;
  const itemSize = 36;

  return (
    <div ref={ref}>
      <div {...other}>
        <List
          key={"list"}
          height={230}
          width={300}
          rowHeight={itemSize}
          overscanCount={5}
          rowCount={itemCount}
          rowRenderer={props => {
            return React.cloneElement(children[props.index], {
              style: props.style
            });
          }}
          role={role}
        />
      </div>
    </div>
  );
});

export default function VirtualizedAutocomplete({
  optionsList = [],
  header = "",
  selectedIds = [],
  onChange = () => {},
  minWidth = "200px",
  width = "initial",
  isSelectAll = false,
  clearFilterData = false,
  reload = false,
  dependentKey = null,
  allCleared = false,
  defaultValue = [],
  parentKey = "",
  limitTags = 1,
  className = "",
  isNewOption = false,
  reportSectionId,
  maxWidth = "300px",
  isRequired = false,
  toolTip = "",
  defaultAll = true
}) {
  // const [selectedId, setSelectedId] = React.useState(selectedIds);
  const [selectedOptions, setSelectedOptions] = useState(defaultValue);
  // eslint-disable-next-line no-unused-vars
  const [value, setValue] = React.useState();

  const allSelected = optionsList.length === selectedOptions.length;
  const handleToggleOption = selectedOptions =>
    setSelectedOptions(selectedOptions);
  const handleClearOptions = () => setSelectedOptions([]);
  const getOptionLabel = option => `${option.value}`;
  useEffect(() => {
    setSelectedOptions(defaultValue);
    setValue([]);
  }, [clearFilterData]);
  useEffect(() => {
    setSelectedOptions(defaultValue);
    setValue([]);
  }, [reload]);

  useEffect(() => {
    if (selectedIds.find(sel => sel === "All") === undefined) {
      setSelectedOptions(
        optionsList.filter(opt => selectedIds.find(sel => sel === opt.value))
      );
    }
  }, [selectedIds]);

  useEffect(() => {
    setSelectedOptions(current =>
      current.filter(e => {
        return e.KeyName !== dependentKey;
      })
    );
  }, [allCleared]);

  /** on click event toggle select all */
  const handleToggleSelectAll = () => {
    handleSelectAll && handleSelectAll(!allSelected);
    return !allSelected;
  };

  /** onclick event select all */
  const handleSelectAll = isSelected => {
    if (isSelected) {
      setSelectedOptions(optionsList);
    } else {
      handleClearOptions();
    }
  };

  /** onclick event handle onchange depends upon conditions */
  const handleChange = (event, selectedOptions, reason, value) => {
    let selectAll = defaultAll === true ?  ["All"] : [];
    if (reason === "select-option" || reason === "remove-option") {
      if (selectedOptions.find(option => option.value === "Select All")) {
        const isSelected = handleToggleSelectAll();
        // let result = [];
        // result = optionsList.filter(el => el.value !== "Select all");
        if (defaultAll === false && reason === "select-option" && isSelected === true) {
          selectAll =  ["All"];
        }
        return onChange(selectAll);
      } else {
        handleToggleOption && handleToggleOption(selectedOptions);
        if(reportSectionId !==7 || reason === "select-option"){
        return selectedOptions.length == 0 && value && value.option
          ? onChange(value.option.value)
          : onChange(removeDuplicates((selectedOptions || []).map(option => option["value"])));
      }
      else{
       return onChange(removeDuplicates((selectedOptions.filter(o=>o.value !== value.option["value"])||[])?.map(option => option["value"])));
      }
    }} else if (reason === "clear") {
      handleClearOptions && handleClearOptions();
      onChange(removeDuplicates((selectedOptions || [])?.map(option => option["value"])));
    } else if (reason === "create-option" && isNewOption === true) {
      const val = selectedOptions.find(x => x.value === undefined);
      selectedOptions = selectedOptions.filter(x => x.value !== undefined);
      const validData = validateEmail(val);
      if (validData.isInErrorState) {
        ShowToast(validData.errorMessage, toastType.ERROR, 5000, 500);
      } else {
        selectedOptions.push({
          value: val,
          id: -(selectedOptions?.length + 1),
          isNewlyAdded: true
        });
      }
      handleToggleOption && handleToggleOption(selectedOptions);

      return selectedOptions.length == 0 && value && value.option
        ? onChange(value.option.value)
        : onChange(selectedOptions || [], true);
    }
  };

  /** Call on blur event */
  const onBlurEvent = value => {
    if (value?.trim()?.length > 0 && isNewOption === true) {
      const validData = validateEmail(value);
      if (validData.isInErrorState) {
        onChange(selectedOptions || [], true, false);
      } else {
        selectedOptions.push({
          value: value,
          id: -(selectedOptions?.length + 1),
          isNewlyAdded: true
        });
        onChange(selectedOptions || [], true);
      }
    }
  };
  
  /** option renderer to control state */
  const optionRenderer = (option, { selected }) => {
    const selectAllProps =
      option && option.value && option.value === "Select All" // To control the state of 'Select all' checkbox
        ? { checked: allSelected }
        : {};
    return (
      <>
        <Checkbox
          key={option?.value + parentKey}
          color={"primary"}
          icon={<CheckBoxOutlineBlankIcon fontSize={"small"} />}
          checkedIcon={<CheckBoxIcon fontSize={"small"} />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };
  const PopperMy = function(props) {
    return (
      <Popper
        key={"Popper" + parentKey}
        {...props}
        style={styles.popper}
        placement={"bottom-start"}
      />
    );
  };
  const styles = () => ({
    popper: {
      width: "fit-content",
      overflow: "hidden"
    }
  });

  const filter = createFilterOptions();
  const renderOptions =
    selectedOptions.filter(sel =>
      optionsList.find(opt => opt.value === sel.value)
    ) || [];
  return (
    <>
      {isNewOption ? (
        <Autocomplete
          freeSolo
          onBlur={e => {
            onBlurEvent(e.target.value);
          }}
          key={"virtualize-demo1" + parentKey}
          PopperComponent={PopperMy}
          className={"virtualized-autocomplete " + className}
          limitTags={limitTags}
          multiple
          disableCloseOnSelect
          id={"virtualize-demo1" + parentKey}
          disableListWrap
          value={removeDuplicates(renderOptions)}
          ListboxComponent={ListboxComponent}
          options={optionsList}
          style={{
            maxWidth: maxWidth,
            minWidth: minWidth,
            width: width,
            fontSize: "0.867rem !important"
          }}
          getOptionLabel={option => option.value}
          getOptionSelected={(option, value) => option.value === value.value}
          filterOptions={
            isSelectAll && optionsList && optionsList.length > 1
              ? (options, params) => {
                  const filtered = filter(options, params);
                  return [{ value: "Select All", label: "Select All" }, ...filtered];
                }
              : (options, params) => {
                  const filtered = filter(options, params);
                  return [...filtered];
                }
          }
          renderOption={optionRenderer}
          onChange={(event, x, y, value) => {
            handleChange(event, x, y, value);
          }}
          renderInput={params => (
            <TextField
              key={"Text" + parentKey}
              inputProps={{
                autoComplete:"off",
                "aria-autocomplete":"none"
              }}
             {...params}
              variant={"standard"}
              label={header}
              fullWidth
              multiline
            />
          )}
        />
      ) : (
        <Autocomplete
          key={"virtualize-demo1" + parentKey}
          autocomplete={"virtualize-demo1" + parentKey}
          PopperComponent={PopperMy}
          className={"virtualized-autocomplete " + className}
          limitTags={limitTags}
          multiple
          disableCloseOnSelect
          id={"virtualize-demo1" + parentKey}
          disableListWrap
          value={removeDuplicates(renderOptions)}
          ListboxComponent={ListboxComponent}
          options={removeDuplicates(optionsList,"value")}
          style={{
            maxWidth: maxWidth,
            minWidth: minWidth,
            width: width,
            fontSize: "0.867rem !important"
          }}
          getOptionLabel={option => option.value}
          getOptionSelected={(option, value) => option.value === value.value}
          filterOptions={
            isSelectAll && optionsList && optionsList.length > 1
              ? (options, params) => {
                  const filtered = filter(options, params);
                  return [{ value: "Select All", label: "Select All" }, ...filtered];
                }
              : (options, params) => {
                  const filtered = filter(options, params);
                  return [...filtered];
                }
          }
          renderOption={optionRenderer}
          onChange={(event, x, y, value) => {
            handleChange(event, x, y, value);
          }}
          renderInput={params => (
            <TextField
              key={"Text" + parentKey}
              id={"Text" + parentKey}
              inputProps={{
                autoComplete:"new-password",
                "aria-autocomplete":"none"
              }}
              name={"new-password"}
              {...params}
              variant={"standard"}
              label={
                isRequired ? 
                  <div className={"label-with-tooltip"}>
                    <span> {header} </span>{"\r"}
                    {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
                    {toolTip && (
                      <>
                        <Tooltip placement={"top-start"} title={toolTip}>
                            <IconButton
                              id={"iconBtn"}
                              size={"small"}
                              className={"tooltip-iconSize"}
                            >
                              <InfoOutlined fontSize={"inherit"} />
                            </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </div> 
                : header
              }
              fullWidth
              
            />
          )}
        />
      )}
    </>
  );
}
VirtualizedAutocomplete.defaultProps = {
  limitTags: 5,
  items: [],
  selectedValues: [],
  getOptionLabel: value => value
};
